<section class="toast-stack">
  <gpei-toast
    *ngFor="let toast of toasts$ | async"
    [attr.type]="toast.level"
    [attr.message]="toast.text"
    [attr.auto-close]="toast?.closeable == null ?? toast.closeable"
    class="toast-stack-item"
    (dismiss)="onDismiss(toast)">
  </gpei-toast>
</section>
